// components
import GridAction from '../../components/common/GridAction';

// Utils
import { dateHeader, formatCellDate } from './timeModeCell';

// Types
import { AppPermissions } from '../../constants/Permissions';
import { TranslationItem } from '../../types/Language';

export const makeLanguageColumn = (
  onUpdateDisplayName: (language: any) => void,
  onDelete: (id: string) => void,
  onEdit: (language: TranslationItem) => void
) => {
  const col = [
    {
      id: 'id',
      header: '',
      accessorKey: 'id',
      size: 75,
      style: { textAlign: 'center' },
      cell: ({ row }) => {
        return (
          <GridAction
            onEdit={onEdit}
            editPermission={AppPermissions.Language.Manage}
            onDeleted={() => onDelete(row.original.isoCode)}
            deletePermission={AppPermissions.Language.Manage}
            row={row.original}
            id={row.original.id}
          />
        );
      },
    },
    {
      header: 'Language',
      accessorKey: 'displayName',
      enableColumnFilter: true,
      size: 200,
      cell: ({ row }) => {
        return (
          <span style={{ textDecoration: 'underline' }} onClick={() => onUpdateDisplayName(row.original)}>
            {row.original.displayName}
          </span>
        );
      },
    },
    {
      header: 'ISO Code',
      accessorKey: 'isoCode',
      enableColumnFilter: true,
      size: 100,
    },
    {
      header: dateHeader('Created'),
      accessorKey: 'createdDateTime',
      size: 110,
      cell: ({ row, table }) => formatCellDate(table, row.original.createdDateTime),
    },
    {
      header: dateHeader('Modified'),
      accessorKey: 'modifiedDateTime',
      size: 110,
      cell: ({ row, table }) => formatCellDate(table, row.original.modifiedDateTime),
    },
  ] as Array<any>;

  return col;
};
